(function () {
  'use strict';

  angular.module('dashboard.employee.sales', ['ngResource']);
})();
